import styled, {css} from 'styled-components'

export const StyledToastContainer = styled.div(
    ({theme: {spacing, typography}}) => css`
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        width: 100%;
        gap: ${spacing * 2}px;
        ${typography.textSm};
    `
)
